import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from "react-bootstrap";
import BootstrapTable from 'react-bootstrap-table-next';
import * as Yup from 'yup';
import moment from 'moment';
import { Control, actions } from 'react-redux-form';
import Select from "react-select";
import DatePicker from 'react-datepicker';
import { getDocketGeneralInfo,getDocumentTypes, changeAction, uploadDocFiles, downloadFiles } from '../../../../actions/docketGeneralInfoAction';
import {mediaPath } from "../../../../config";
import ReactHtmlParser from 'react-html-parser';
import { showHideModal, resetModalValues, showHideThankYouModal,notification } from '../../../../actions/uiAction';
import Dropzone from "react-dropzone";
const dropzoneRef = React.createRef();
let dropzone = props => <Dropzone {...props} />;

const uploadFilesSchema = Yup.object().shape({
	documentType: Yup.string()
		.required('Please select a document type.'),
	files: Yup.array()
		.min(1,'Please drag a file here or choose a file to upload.'),
	documentName: Yup.string()
				  .matches(/^[ \w-_.,]+$/,  {
						message:'Please update the file name so it does not include a special character.',
						excludeEmptyString: true
				}),
});
class DocketDocuments extends Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			showModal: false,
			hideShow: false,
			altaddress: false,
			uploadErrorId:'',
			maxFileSize:262144000
		};
		props.getDocumentTypes();
	}

	handleShow() {
		this.props.showHideModal(true);
		this.props.resetModalValues("uploadFile");

	}
	
	showReadMore(value) {
			this.setState({ showDescriptionModal: true });
			this.setState({ showDescription: value });
	}
	handleClose(flag) {
		 if (flag === 'thankyou') {
			this.props.showHideThankYouModal(false);
		}else if(flag=== 'readMore'){
			this.setState({ showDescriptionModal: false });
		}else {
			this.props.showHideModal(false);
		}
	}

	render() {
		const MAX_LENGTH = 250;
		const documentsInfo = this.props.docketGeneralInfo.Documents || [];
		const documentTypesOptions = this.props.docketGeneralInfo.documentTypes || [];
		let files = this.props.uploadFile.files;
		const docketInfo = this.props.docketGeneralInfo.DocketInfo || [];

		const columns = [
			{
				dataField: 'DocumentType',

				text: 'Document ',
				sort: true,
				headerClasses: 'document',
				classes: 'document',
				sortCaret: (order, column) => {
					return (!order || order === 'desc') ?  <i className="fa fa-angle-down"></i> : <i className="fa fa-angle-up"></i>;
				}

			},
			{
				dataField: 'DateRequested',

				text: 'Date Submitted  ',
				sort: true,
				headerClasses: 'date',
				classes: 'date',
				sortCaret: (order, column) => {
					return (!order || order === 'desc') ?  <i className="fa fa-angle-down"></i> : <i className="fa fa-angle-up"></i>;
				}
			},
			{
				dataField: 'Description',

				text: 'Description ',
				sort: true,
				headerClasses: 'desc',
				classes: 'desc',
				sortCaret: (order, column) => {
					return (!order || order === 'desc') ?  <i className="fa fa-angle-down"></i> : <i className="fa fa-angle-up"></i>;
				},
				formatter: (value, row, index, field) => {
					return (row.Description!=null && row.Description!='') ? row.Description.length > MAX_LENGTH ?( <div>
								 {ReactHtmlParser(`${row.Description.substring(0, MAX_LENGTH)}...`)}<a href="javascript:;" onClick={() => { this.showReadMore(row.Description) }}>Read more</a>
					</div>) : ReactHtmlParser(row.Description) : '-'   
				}
			},
			{
				classes: 'download',
				dataField: 'Download',
				text: '',
				formatter: (value, row) => {
					return (
						<a href="javascript:;" aria-label="Download document" onClick={() => this.props.downloadFiles(row.documentid, '1','internal')}><i className="fa fa-download"></i><span>Download</span></a>
					);
				},

			},
		];
		const defaultSorted = [{
			dataField: 'DateRequested',
			order: 'asc'
		}];
		return (
			<div>
				<h2>Documents</h2>
				<div>
					<BootstrapTable wrapperClasses="boo" keyField='documentid' data={documentsInfo} columns={columns} defaultSorted={defaultSorted} noDataIndication={'No records found.'} bordered={false} />
				</div>
				<div>
					{docketInfo.status != 'Closed' ? <button className="upload-button" onClick={() => { this.handleShow() }}><i className="fa fa-upload"></i> eFile</button> : <div></div>}
				</div>
			<Modal show={this.props.uiState.modalHideShow}
				onHide={() => this.handleClose("files")}
				backdrop="static" id="upload-files"
				className="modal fade select-files">
				<Modal.Header>
    				<button type="button" className="close" onClick={() => this.handleClose("files")} ><img src={mediaPath+"close.png"} alt="close" /></button>
					<h4 className="modal-title">eFile Documents</h4>
				</Modal.Header>
				<Modal.Body>
						<div className="row">
							<div className="col-xs-12">
								<p className="note">OSAH is not responsible for any documents that have been uploaded with confidential information.</p>
							</div>
						</div>
						<div className="row">
							<div className="col-xs-6">
								<label aria-label="Docket Number *">Docket Number *
								<Control.text model="uploadFile.docketno" disabled required value={docketInfo.caseid}
								/></label>
							</div>
							<div className="col-xs-6">
								<label aria-label="Document Type *">Document Type <sup>*</sup>
								<Control.custom
									component={props => <Select {...props} className="react-select" />}
									model="uploadFile.documentType"
									options={documentTypesOptions}
									getOptionLabel={({ documenttype }) => documenttype}
									getOptionValue={({ documenttype }) => documenttype}
									value={documentTypesOptions.find(v => v.documenttype === this.props.uploadFile.documentType)}
									mapProps={{ onChange: (props) => props.onChange }}
									changeAction={(model, value) =>
										dispatch => {
											dispatch(actions.change('uploadFile.documentType', value.documenttype))
											dispatch(actions.change('uploadFile.docketno', docketInfo.caseid))
										}
									}
								/></label>
							</div>
						</div>
						<div className="row">
							<div className="col-xs-12">
								<label aria-label="Document Name">Document Name
								<Control.text model="uploadFile.documentName" disabled required value={this.props.uploadFile.documentName} />
								</label>
							</div>
						</div>
						<div className="row">
							<div className="col-xs-12">
								<label aria-label="Description">Description
								<Control.textarea model="uploadFile.description" required value={this.props.uploadFile.description} />
								</label>
							</div>
						</div>

						<div className="row">
							<div className="col-xs-12">
								<label aria-label="Add Files">Add Files</label>
								<Control.custom
									component={dropzone}
									model="uploadFile.files"
									mapProps={{ onDrop: (props) => props.onChange }}
									disableClick={files.length ? true : false}
									multiple={false}
									minSize={1024}
									maxSize={this.state.maxFileSize}
									ref={dropzoneRef}
									accept= ".png,.jpeg,.jpg,.pdf"
									className="dropzone-container"
								>
								{({rejectedFiles}) =>(
									<div className={"textarea-section" + (files.length ? ' files-listed ' : '')} >
										{rejectedFiles.length&&rejectedFiles[0].preview!=this.state.uploadErrorId?(
											this.setState({uploadErrorId:rejectedFiles[0].preview}),
											this.props.notification(
												(rejectedFiles[0].size>=this.state.maxFileSize)?'Please upload a file that is less than 250MB.':'Please upload an accepted file type.'
											)
										)
										:''}
										<div className={"textarea-section-inner" + (files.length ? ' hide ' : '')}>
											<span>Drag & Drop File Here</span>
											<span>or</span>
											<a className="btn">Choose File to Upload</a>
										</div>
										{files.map((f, k) => (
											(f.name && <div key={k} className="dz-preview dz-file-preview dz-processing dz-success dz-complete">

												<div className="dz-image">
													{['image/png', 'image/jpeg', 'image/jpg'].indexOf(f.type) >= 0 &&
														<div className="img" style={{ background: "url(" + f.preview + ")" }}>
														</div>
													}
												</div>
												<div className="dz-details">
													<div className="dz-filename"><span>{f.name}</span></div>
													{this.props.changeAction("uploadFile.documentName", f.name)}
												</div>

												<div className="dz-error-message"><span>This is error</span></div>
												<a className="dz-remove" onClick={() => {
													let _files = [...files];
													_files.splice(k, 1);
													this.props.changeAction("uploadFile.files", _files)
													this.props.changeAction("uploadFile.documentName", '')
												}}>Remove file</a>
											</div>)
										))}
										<div onClick={() => { dropzoneRef.current.open() }} className={"dz-preview dz-file-preview dz-processing dz-success dz-complete" + (files.length && dropzoneRef && dropzoneRef.current && dropzoneRef.current.props.multiple ? '' : ' hide ')}>
											<div className="dz-image add-more-files">
												<div className={"textarea-section-inner"}>
													<span>Drag & Drop File Here</span>
													<span>or</span>
													<span>Choose File to Upload</span>
												</div>
											</div>
										</div>
									</div>
								)}
								</Control.custom>
								<p className="note">Note: You can only upload one file at a time. Files should be no larger than 250MB. Accepted file types are PDF, JPG and PNG. File names should not contain special characters such as: !@#$%^&*().</p>
							</div>
							<div className="row">
								<div className="col-xs-12">
									<p>* Required</p>
								</div>
							</div>
						</div>
					</Modal.Body>
    			<Modal.Footer>
					<div className="btn-block">
						<button type="button" className="btn cancel" onClick={() => this.handleClose("files")}>Close</button>
						<button type="button" className="btn btn-default" onClick={() => this.props.uploadDocFiles(this.props.uploadFile, uploadFilesSchema)}><i className="fa fa-paperclip" aria-hidden="true"></i> eFile</button>
					</div>
				</Modal.Footer>
			</Modal>
			<Modal show={this.props.uiState.hideShowThankYouModal}
			onHide={() => this.handleClose()}
			backdrop="static" id="doc-thankyou"
			className="modal fade">
				<Modal.Header>
					<button type="button" onClick={() => this.handleClose("thankyou")} className="close" data-dismiss="modal">
						<img src={mediaPath+"close.png"} alt="close" />
					</button>
				</Modal.Header>
				<Modal.Body>
					<div className="row">
						<div className="col-xs-12">
							<h2>Thank you!</h2>
						</div>
					</div>
					<div className="row">
						<div className="col-xs-12">
							<p className="note">Your documents have been uploaded. Please allow 24-48 hours for your document to be reviewed and added to the docket.</p>
						</div>
					</div>
					<div className="row">
						<div className="col-xs-12">
							<p className="note">If something is incorrect or missing, your document will be rejected and you will receive an email notification with specific instructions to correct the error.</p>
						</div>
					</div>
					<div className="row">
						<div className="col-xs-12">
							<p className="note">
								<h4>REMINDER:</h4>  
								Submitting documents via ePortal does NOT satisfy service requirements.  You are still required to simultaneously deliver copies of your documents to opposing parties (by first-class mail, email, fax, personal delivery).  You must also submit proof of service to OSAH. <a className="notice-link" href="https://eportal.osah.ga.gov/eService requirements/administrative_rules_osah.pdf" target="_blank"><span>Click here</span> review OSAH's Service Rule, 616-1-2-.11.</a> 
							</p>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<div className="btn-block">
						<button type="button" onClick={() => this.handleClose("thankyou")} className="btn cancel">Close Window</button>
					</div>
				</Modal.Footer>
			</Modal>
			
			<Modal show={this.state.showDescriptionModal}
						onHide={() => this.handleClose()}
						backdrop="static" id="read-more"
						className="modal fade">
						<Modal.Header>
							<button type="button" onClick={() => this.handleClose("readMore")} className="close" data-dismiss="modal">
								<img src={mediaPath+"close.png"} alt="close" />
							</button>
							<h4 className="modal-title">View Description</h4>
						</Modal.Header>
						<Modal.Body>
							<div className="row">
								<div className="col-xs-12">
									<p className="note">{ReactHtmlParser(this.state.showDescription)}</p>
								</div>
							</div>
						</Modal.Body>
						<Modal.Footer>
							<div className="btn-block">
								<button type="button" onClick={() => this.handleClose("readMore")} className="btn cancel">Close Window</button>
							</div>
						</Modal.Footer>
					</Modal>
		</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		docketGeneralInfo : state.docketGeneralInfo,
		uploadFile : state.uploadFile,
		uiState : state.uiState,
	};
}

export default connect(mapStateToProps, { getDocketGeneralInfo, showHideModal, resetModalValues, showHideThankYouModal, getDocumentTypes, changeAction, uploadDocFiles, downloadFiles, notification })(DocketDocuments);